import React from "react";

type OverlayWrapperProps = {
  isLoading: boolean;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void;
  divRef?: React.Ref<HTMLDivElement>;
};

const OverlayWrapper: React.FC<OverlayWrapperProps> = ({
  isLoading,
  children,
  className,
  onClick,
  divRef,
  onMouseDown,
}) => {
  return (
    <div
      className={`relative ${className}`}
      ref={divRef}
      onClick={onClick}
      onMouseDown={onMouseDown}
    >
      {isLoading && (
        <div
          className="absolute inset-0 bg-gray-500 bg-opacity-15 z-50 pointer-events-none rounded-md"
          aria-hidden="true"
        ></div>
      )}
      {children}
    </div>
  );
};

export default OverlayWrapper;
